// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

// Images
import greyTickIcon from '../../static/images/grey-tick-icon.png';
import { AuthResource } from 'components';
import { toast } from 'react-toastify';   

import './merchantOnboard.scss'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const UserActionsMob = ({
    auth,
    data,
    actionType,
    history,
    isEditOnly,
    onSetId,
    tableType,
    reduxActions,
}) => {
    const handleEditView = (actionType) => {
        const { email } = data.original;
        onSetId(email);
        if (isEditOnly) {
            history.push(`/mob/create/merchant`);
        } else {
            const { entityCode } = data.original;
            if (actionType === 'edit') {
                history.push(`/mob/draft/merchant/${entityCode}`);
            } else if (actionType === 'view') {
                history.push(`/mob/draft/view/merchant/${entityCode}`);
            }
        }
    };

    const handleRetryClick = () => {
        const formDetails = data.original;
        const request = {
            formIdentifier: formDetails.email,
        };
        reduxActions.retryFailedMerchantFormRequest(request);
    };

    const handleEditClick = () => {
        toast.error('Access Denied. User doesn’t have required permissions. Please contact support.');
    };

    const hasEditPermission = auth?.resourceDetails?.permissions?.edit_merchant_onboarding?.includes('edit_merchant');
    const hasViewPermission = auth?.resourceDetails?.permissions?.edit_merchant_onboarding?.includes('view_merchant');
    const hasCreatePermission = auth?.resourceDetails?.permissions?.merchant_onboarding?.includes('create_merchant');

    return (
        <div className="userAction multiItem">
            {tableType !== 'inactive' ? (
                <>
                    {hasCreatePermission ? (
                        <>
                            <button
                                className="edit"
                                id="edit-merchant"
                                onClick={() => handleEditView('edit')}
                            />
                            <button
                                className="view"
                                id="view-merchant"
                                onClick={() => handleEditView('view')}
                            />
                        </>
                    ) : (
                        <>
                            {hasEditPermission && (
                                <button
                                    className="edit"
                                    id="edit-merchant"
                                    onClick={() => handleEditView('edit')}
                                />
                            )}

                            {hasViewPermission && !hasEditPermission && (
                                <button
                                    className="edit"
                                    id="edit-merchant"
                                    onClick={handleEditClick}
                                />
                            )}

                            {tableType !== 'draft' && (
                                <button
                                    className="view"
                                    id="view-merchant"
                                    onClick={() => handleEditView('view')}
                                />
                            )}
                        </>
                    )}
                </>
            ) : (
                <>
                    <button
                        className={`edit ${!data.original.isEditMode ? 'block' : ''}`}
                        id="edit-merchant"
                        onClick={() => handleEditClick()}
                        disabled={!data.original.isEditMode}
                    />
                </>
            )}
        </div>
    );
};


UserActionsMob.propTypes = {
    auth: PropTypes.object,
    actionType: PropTypes.string,
    data: PropTypes.object.isRequired,
    history: PropTypes.object,
    isEditOnly: PropTypes.bool,
    onSetId: PropTypes.func,
    tableType: PropTypes.string,
    reduxActions: PropTypes.object,
};

/**
 * Maps the Redux state to the component props.
 *
 * @param {Object} state - The Redux state.
 * @param {Object} state.auth - The authentication state.
 * @returns {Object} The mapped props.
 */

const mapStateToProps = ({ auth }) => ({
    auth,
});

/**
 * Maps the dispatch function to the component props.
 *
 * @param {Function} dispatch - The Redux dispatch function.
 * @returns {Object} The mapped props with action creators.
 */
const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({}, dispatch),
});


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserActionsMob));




